// extracted by css-extract-rspack-plugin
export default {"overEllipsis":"overEllipsis-ylo2nz"};